/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type ImportPipedriveOrganizationsInput = {
    clientIds?: Array<string | null> | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type ImportPipedriveOrganizationsMutationVariables = {
    input: ImportPipedriveOrganizationsInput;
};
export type ImportPipedriveOrganizationsMutationResponse = {
    readonly importPipedriveOrganizations: {
        readonly clients: ReadonlyArray<{
            readonly cursor: string;
            readonly node: {
                readonly id: string;
                readonly name: string | null;
                readonly street: string | null;
                readonly zip: string | null;
                readonly city: string | null;
                readonly vat: string | null;
                readonly country: string | null;
                readonly notes: string | null;
                readonly logoId: string | null;
                readonly logoDefaultId: number | null;
            } | null;
        } | null> | null;
    } | null;
};
export type ImportPipedriveOrganizationsMutation = {
    readonly response: ImportPipedriveOrganizationsMutationResponse;
    readonly variables: ImportPipedriveOrganizationsMutationVariables;
};



/*
mutation ImportPipedriveOrganizationsMutation(
  $input: ImportPipedriveOrganizationsInput!
) {
  importPipedriveOrganizations(input: $input) {
    clients {
      cursor
      node {
        id
        name
        street
        zip
        city
        vat
        country
        notes
        logoId
        logoDefaultId
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "ImportPipedriveOrganizationsInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ImportPipedriveOrganizationsPayload",
    "kind": "LinkedField",
    "name": "importPipedriveOrganizations",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ClientTypeEdge",
        "kind": "LinkedField",
        "name": "clients",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cursor",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Client",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "street",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "zip",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "city",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vat",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "country",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "notes",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "logoId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "logoDefaultId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ImportPipedriveOrganizationsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ImportPipedriveOrganizationsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "ImportPipedriveOrganizationsMutation",
    "operationKind": "mutation",
    "text": "mutation ImportPipedriveOrganizationsMutation(\n  $input: ImportPipedriveOrganizationsInput!\n) {\n  importPipedriveOrganizations(input: $input) {\n    clients {\n      cursor\n      node {\n        id\n        name\n        street\n        zip\n        city\n        vat\n        country\n        notes\n        logoId\n        logoDefaultId\n      }\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '67842751ca223fbf59adc97bbb99ac24';
export default node;
